export const FETCH_ANALYZE_DATA_REQUEST = 'FETCH_ANALYZE_DATA_REQUEST';
export const DELETE_INTERACTIVE_REQUEST = 'DELETE_INTERACTIVE_REQUEST';
export const CLONE_INTERACTIVE_REQUEST = 'CLONE_INTERACTIVE_REQUEST';
export const FETCH_PROPERTIES_REQUEST = 'FETCH_PROPERTIES_REQUEST';
export const FETCH_DETAILS_REQUEST = 'FETCH_DETAILS_REQUEST';
export const FETCH_ANALYZE_POINTS_REQUEST = 'FETCH_ANALYZE_POINTS_REQUEST';
export const CREATE_INTERACTIVE_REQUEST = 'CREATE_INTERACTIVE_REQUEST';
export const FETCH_TEMPLATES_REQUEST = 'FETCH_TEMPLATES_REQUEST';
export const ARCHIVE_INTERACTIVES_REQUEST = 'ARCHIVE_INTERACTIVES_REQUEST';
export const UNPUBLISH_INTERACTIVE_REQUEST = 'UNPUBLISH_INTERACTIVE_REQUEST';
export const FETCH_EMBED_CODE_REQUEST = 'FETCH_EMBED_CODE_REQUEST';
export const FETCH_PREVIEW_PAGES_REQUEST = 'FETCH_PREVIEW_PAGES_REQUEST';
export const RUN_AB_TEST_REQUEST = 'RUN_AB_TEST_REQUEST';
export const PICK_AB_TEST_WINNER_REQUEST = 'PICK_AB_TEST_WINNER_REQUEST';
export const GENERATE_AI_CTA_REQUEST = 'GENERATE_AI_CTA_REQUEST';